import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Home, Heart, MapPin, CheckCircle2 } from "lucide-react";
import { PawScatter } from "@/components/Icons";
import Reveal from "@/components/Reveal";

const icons = [Home, Heart, MapPin, CheckCircle2];

const WhyUs = () => {
  const { t } = useLang();
  return (
    <section className="section-blush py-20 sm:py-28 relative overflow-hidden" data-testid="why-us-section">
      <PawScatter />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <Reveal className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl">{t.why.title}</h2>
          <p className="text-[#6b3f2a]/75 mt-4 text-sm sm:text-base">{t.why.subtitle}</p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {t.why.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={i} delay={i * 80}>
                <article
                  className="bg-white rounded-3xl p-6 h-full shadow-[0_6px_20px_rgba(107,63,42,0.06)] hover:-translate-y-1 transition-transform text-center"
                  data-testid={`why-card-${i}`}
                >
                  <div className="w-12 h-12 rounded-2xl bg-[#fdf3ec] flex items-center justify-center text-[#f4956a] mb-4 mx-auto">
                    <Icon size={22} />
                  </div>
                  <h3 className="font-display text-lg mb-2">{item.title}</h3>
                  <p className="text-[#6b3f2a]/80 text-sm leading-relaxed">{item.text}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
